import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { TextField } from '@mui/material';

 const CustomInput = styled(TextField, {
    shouldForwardProp: (prop) => !['primaryColor', 'bgColor', 'textColor'].includes(prop),
  })(({ theme, primaryColor, bgColor, textColor }) => ({
    'label + &': {
        
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: 4,
      color: textColor || '#1F1F1F',
      position: 'relative',
      backgroundColor: bgColor || 'white',
      border: '1.8px solid',
      borderColor: alpha(primaryColor || '#D6D6D6', 1),
      fontSize: 16,
      padding: '15px 12px',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
      ]),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        boxShadow: `${alpha(primaryColor || theme.palette.primary.main, 1)}`,
        borderColor: primaryColor || theme.palette.primary.main,
      },
      '& label': {
      color: textColor || '#000',
    },
    },
  })); 

 const CustomInput1 = styled(TextField, {
    shouldForwardProp: (prop) => !['primaryColor','secondaryColor', 'bgColor', 'textColor'].includes(prop),
  })(({ theme, primaryColor, secondaryColor, bgColor, textColor }) => ({
    '& .MuiOutlinedInput-root': {
      backgroundColor: bgColor || '#fff',
      borderRadius: 4,
      '& input': {
        color: textColor || '#141414',
      },
      '& fieldset': {
        borderColor: secondaryColor || '#D6D6D6',
      },
      '&:hover fieldset': {
        borderColor: primaryColor || '#ADADAD',
      },
      '&.Mui-focused fieldset': {
        borderColor: primaryColor || theme.palette.primary.main,
        borderWidth: 2,
      },
      
    },
    '& label': {
      color: textColor || '#858585',
    },
  })); 

const CustomTextField = (props) => {
  return (
    <CustomInput1 
      {...props}
      id="bootstrap-input"
    />
  );
};

export default CustomTextField;